import {DynamicSearchPayload} from "@ispm-shared/modules/common/dynamic-search";
import { IUrlParams } from '@ispm/core/interfaces/router-handler.interface';
import { ISimpleSearchConfig, ISimpleSearchQuery } from "../../../worklist/interfaces/simple-search.interface";

export enum AdvancedSearchType {
  Patient = 'patient',
  Test = 'test'
}

export enum AdvancedSearchResourceType {
  Patient = 'Patient',
  UIPractWorkListRow = 'UIPractWorkListRow'
}

export interface IDisplayColumn {
  paths: string;
  title: string;
  pathsSeperator?: string;
  prefix?: string;
  suffix?: string;  
}
export interface IDisplayConfig {
  type: AdvancedSearchType;
  title: string;
  displayColumn: IDisplayColumn[];
}

export interface IAdvancedSearchConfiguration {
  placeholder: string;
  queryConfig: Array<IAdvancedSearchQueryConfiguration>;
  displayConfig: Array<IDisplayConfig>;
  stateToGo: Array<IStateToGo>;
  searchDebounce ?: number;
}

export interface IStateToGo {
  type: AdvancedSearchType;
  routes: Array<IUrlParams>;
}

export interface IAdvancedSearchQueryConfiguration {
  dataQuery: DynamicSearchPayload;
  type: AdvancedSearchType;
  resource ?: string;
  queryType ?: string;
  simpleSearchConfig ?: ISimpleSearchConfig;
  simpleSearchQuery ?: ISimpleSearchQuery;
}
export interface ITestNavigateParameters {
  //Navigation parameters must contains at least revisionId and workflowRequestId
  revisionId: string;
  testId: string;
  patientId?: string;
  type?: string;
  orderId?: string;
}
